module.exports = __webpack_public_path__ + "img/blockGq2-4.3480b3d0.svg";